const protocolRe = /http(s)?:/;
const removeProtocol = function(t = '') {
    return t.replace(protocolRe, '');
};
/**
 * @description Port of Shopify `getSizedImageUrl` utility
 */ export const getSizedImageUrl = function(url, size) {
    if (url == null) {
        return null;
    }
    if (url.indexOf('shopify.com') < 0) {
        return url;
    }
    if (size == null) {
        return url;
    }
    if (size === 'master') {
        return removeProtocol(url);
    }
    const cleanUrl = removeProtocol(url);
    return cleanUrl.replace(/(.+)(_)((?:pico|icon|thumb|small|compact|medium|large|grande)|\d{1,4}x\d{0,4}|x\d{1,4})([_.@].+)/, function(_, head, underscore, _oldSize, tail) {
        return head + underscore + size + tail;
    });
};
